import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IconName, Stack } from '@optimus-web/core';
import { TooltippedIcon } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { getCustomer } from '@mews-commander/legacy-entities/src/ducks/customers';
import { CustomerLink } from '../../../../components/commander-ui';
import { editInternal as editInternalsAction } from '../../actions/profile';
import { openBillingAccount } from '../../actions';

const BookerLabel = ({ bookerId, openBillingScreen, editInternals, customer }: $TSFixMe) => {
    if (!customer) {
        return null;
    }
    const { notes } = customer;

    return (
        <Stack itemAlignment="center" spacing="100" inline>
            <TooltippedIcon value={IconName.PaymentReport} tooltip={TextKey.Billing} onClick={openBillingScreen} />
            <CustomerLink id={bookerId} />
            {notes ? <TooltippedIcon value={IconName.Notes} tooltip={notes} onClick={editInternals} /> : null}
        </Stack>
    );
};

export default connect(
    createStructuredSelector({
        customer: (state: $TSFixMe, { bookerId }: $TSFixMe) => getCustomer(state, { id: bookerId }),
    }),
    (dispatch, { bookerId, refetchGroup }) => ({
        // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
        editInternals: () => dispatch(editInternalsAction({ accountId: bookerId, onClose: refetchGroup })),
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
        openBillingScreen: () => dispatch(openBillingAccount({ accountId: bookerId })),
    })
)(BookerLabel);
